/**
 * This function receive truestory object from detail request and return an object of edit form values.
 * It doesn't process images because processing images takes more time so better to do separately.
 */
const parseStoryToFormValues = story => ({
  petType: story.petType._id, // *
  breed: story.breed._id, // *
  petName: story.petName, // *
  petAge: story.age,
  dietaryGoals: story.dietaryGoals.map(goal => goal._id),
  content: story.content, // * 500 character min length
  products: story.products,
  termsAndConditions: [],
});

export default parseStoryToFormValues;
